<template>
  <div class="2xl:container 2xl:my-20 relative">
    <FixedAspect :ratio="ratio">
      <CldnImg
        v-if="image && image[0]"
        :src="image[0].url"
        :alt="image[0].title"
        sizes="100vw sm:100vw md:100vw lg:100vw xl:100vw 2xl:100vw"
        crop="fill"
      />
    </FixedAspect>
    <div class="absolute inset-0 z-10">
      <div class="md:mt-32 md:flex-row md:px-20 2xl:px-32 z-10 flex flex-col items-baseline justify-between px-4 mt-8">
        <h2 class="flow-root mr-auto fluid-4xl leading-none" :class="{ 'mac-os': isMac }" v-html="heading"></h2>
        <CtaArrow v-bind="cta[0]" class="block mt-4 text-white" />
      </div>
    </div>
    <div
      v-if="articles"
      class="md:absolute md:top-0 md:right-0 md:mt-48 lg:mt-64 md:w-1/2 md:pr-20 2xl:pr-32 container z-10"
    >
      <div class="md:text-white mt-8 fluid-xl leading-tight font-medium">{{ articlesHeading }}</div>
      <div class="md:flex-nowrap md:space-x-16 flex flex-row flex-wrap mt-4">
        <ArticlePreview
          v-for="article in articles"
          :key="article.id"
          :article="article"
          class="md:text-white md:w-1/2 flex-row w-full pb-8"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CldnImg from '@/components/CldnImg';
import FixedAspect from '@/components/common/FixedAspect';
import ArticlePreview from '@/components/article/ArticlePreview';
import CtaArrow from '@/components/common/CtaArrow';

export default defineNuxtComponent({
  components: {
    CldnImg,
    FixedAspect,
    CtaArrow,
    ArticlePreview,
  },
  props: {
    topic: {
      type: Array,
      default: () => [],
    },
    image: {
      type: Array,
      default: () => [],
    },
    articles: {
      type: Array,
      default: () => [],
    },
    heading: {
      type: String,
      default: null,
    },
    articlesHeading: {
      type: String,
      default: null,
    },
    cta: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ratio: 2 / 3,
    };
  },
  computed: {
    isMac() {
      return process.browser && navigator.userAgent?.indexOf('Mac OS X') !== -1;
    },
  },
});
</script>
